module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-10-12 at 10.18.40 PM.e0b994f2.png";